import './App.css';
import ChatBotFrame from './components/modal/ChatBotFrame';
import Home from './components/pages/Home';

function App() {
  return (
    <div className="App">
    <Home />
      <ChatBotFrame />
    </div>
  );
}

export default App;